import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      Yoga Refer ©{new Date().getFullYear()} Created by Greenwill Techs
    </Footer>
  );
};

export default AppFooter;
